import { safeExecute } from "@opendaw/lib-std";
import { Box, NoPointers, StringField, PointerField, Field, Int32Field, Float32Field, BooleanField, } from "@opendaw/lib-box";
import { Pointers } from "@opendaw/studio-enums";
export class AudioUnitBox extends Box {
    static create(graph, uuid, constructor) {
        return graph.stageBox(new AudioUnitBox({
            uuid,
            graph,
            name: "AudioUnitBox",
            pointerRules: {
                accepts: [Pointers.Selection, Pointers.Automation],
                mandatory: false,
            },
        }), constructor);
    }
    static ClassName = "AudioUnitBox";
    constructor(construct) {
        super(construct);
    }
    accept(visitor) {
        return safeExecute(visitor.visitAudioUnitBox, this);
    }
    get type() {
        return this.getField(1);
    }
    get collection() {
        return this.getField(2);
    }
    get editing() {
        return this.getField(3);
    }
    get index() {
        return this.getField(11);
    }
    get volume() {
        return this.getField(12);
    }
    get panning() {
        return this.getField(13);
    }
    get mute() {
        return this.getField(14);
    }
    get solo() {
        return this.getField(15);
    }
    get tracks() {
        return this.getField(20);
    }
    get midiEffects() {
        return this.getField(21);
    }
    get input() {
        return this.getField(22);
    }
    get audioEffects() {
        return this.getField(23);
    }
    get auxSends() {
        return this.getField(24);
    }
    get output() {
        return this.getField(25);
    }
    get capture() {
        return this.getField(26);
    }
    initializeFields() {
        return {
            1: StringField.create({
                parent: this,
                fieldKey: 1,
                fieldName: "type",
                pointerRules: NoPointers,
            }, "instrument"),
            2: PointerField.create({
                parent: this,
                fieldKey: 2,
                fieldName: "collection",
                pointerRules: NoPointers,
            }, Pointers.AudioUnits, true),
            3: Field.hook({
                parent: this,
                fieldKey: 3,
                fieldName: "editing",
                pointerRules: { accepts: [Pointers.Editing], mandatory: false },
            }),
            11: Int32Field.create({
                parent: this,
                fieldKey: 11,
                fieldName: "index",
                pointerRules: NoPointers,
            }),
            12: Float32Field.create({
                parent: this,
                fieldKey: 12,
                fieldName: "volume",
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MidiControl,
                    ],
                    mandatory: false,
                },
            }),
            13: Float32Field.create({
                parent: this,
                fieldKey: 13,
                fieldName: "panning",
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MidiControl,
                    ],
                    mandatory: false,
                },
            }),
            14: BooleanField.create({
                parent: this,
                fieldKey: 14,
                fieldName: "mute",
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MidiControl,
                    ],
                    mandatory: false,
                },
            }),
            15: BooleanField.create({
                parent: this,
                fieldKey: 15,
                fieldName: "solo",
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MidiControl,
                    ],
                    mandatory: false,
                },
            }),
            20: Field.hook({
                parent: this,
                fieldKey: 20,
                fieldName: "tracks",
                pointerRules: {
                    accepts: [Pointers.TrackCollection],
                    mandatory: false,
                },
            }),
            21: Field.hook({
                parent: this,
                fieldKey: 21,
                fieldName: "midiEffects",
                pointerRules: {
                    accepts: [Pointers.MidiEffectHost],
                    mandatory: false,
                },
            }),
            22: Field.hook({
                parent: this,
                fieldKey: 22,
                fieldName: "input",
                pointerRules: {
                    accepts: [Pointers.InstrumentHost, Pointers.AudioOutput],
                    mandatory: false,
                },
            }),
            23: Field.hook({
                parent: this,
                fieldKey: 23,
                fieldName: "audioEffects",
                pointerRules: {
                    accepts: [Pointers.AudioEffectHost],
                    mandatory: false,
                },
            }),
            24: Field.hook({
                parent: this,
                fieldKey: 24,
                fieldName: "auxSends",
                pointerRules: { accepts: [Pointers.AuxSend], mandatory: false },
            }),
            25: PointerField.create({
                parent: this,
                fieldKey: 25,
                fieldName: "output",
                pointerRules: NoPointers,
            }, Pointers.AudioOutput, false),
            26: PointerField.create({
                parent: this,
                fieldKey: 26,
                fieldName: "capture",
                pointerRules: NoPointers,
            }, Pointers.Capture, false),
        };
    }
}
